import { render, staticRenderFns } from "./InvitationRecieptDetail.vue?vue&type=template&id=4e96a832&scoped=true&"
import script from "./InvitationRecieptDetail.vue?vue&type=script&lang=js&"
export * from "./InvitationRecieptDetail.vue?vue&type=script&lang=js&"
import style0 from "./InvitationRecieptDetail.vue?vue&type=style&index=0&id=4e96a832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e96a832",
  null
  
)

export default component.exports